import type { AnalyticsSender } from '@funtech-int/yango-shared';

import {
    playerContentFinishedV2,
    playerContentStartedV2,
} from '@kinopoisk-int/evgen-web-events/web/player';
import {
    Orientation,
    PlayerContentType,
    PlayerPlayMode,
    RemoteMode,
} from '@kinopoisk-int/evgen-web-events/web/named_enums';

const typenameToEvgenContentType: Record<string, PlayerContentType> = {
    Film: PlayerContentType.Film,
    Episode: PlayerContentType.Episode,
    Video: PlayerContentType.Film,
    TvChannel: PlayerContentType.TvChannel,
    OttTrailer: PlayerContentType.Trailer,
};

export interface PlayerEventParams {
    contentId: string;
    psid: string;
    manifestUrl: string;
    contentTypename: string;
    vsid: string;
    isDynamicPrerollEnabled: boolean;
}

function buildEvgenPlayerPayload(eventParams: PlayerEventParams) {
    return {
        vsid: eventParams.vsid,
        contentType:
            typenameToEvgenContentType[eventParams.contentTypename] ?? PlayerContentType.Film,
        filmId: eventParams.contentId,
        orientation: Orientation.Horizontal,
        remoteMode: RemoteMode.Disabled,
        playMode: PlayerPlayMode.Online,
        contentId: eventParams.contentId,
        psid: eventParams.psid,
        manifestUrl: eventParams.manifestUrl ?? '',
    };
}

export const createAnalyticsEvents = (eventSender: AnalyticsSender) => ({
    contentStarted(eventParams: PlayerEventParams) {
        eventSender.send(playerContentStartedV2, buildEvgenPlayerPayload(eventParams));
    },
    contentFinished(eventParams: PlayerEventParams) {
        eventSender.send(playerContentFinishedV2, buildEvgenPlayerPayload(eventParams));
    },
});
